module.exports = __webpack_public_path__ + "img/ic_superdoc_ava.6b2cc0a0.svg";